const statusOptions = [
    { label: "Ganho", value: "won" },
    { label: "Perdido", value: "lost" },
    { label: "Aberto", value: "open" },
    { label: "Arquivado", value: "archived" },
    // { label: "Congelado", value: "frozen" }
];

export default statusOptions;